'use es6';

import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import PropTypes from 'prop-types';
import { VideoParamTypes } from '../../constants/video';
import { jsx as _jsx } from "react/jsx-runtime";
const renderVideoParamCheckbox = (paramType, value, onChange) => {
  return /*#__PURE__*/_jsx(Checkbox, {
    checked: !!value,
    onChange: () => onChange(paramType, !value),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `RichTextLib.video.advanced.params.${paramType}`
    })
  }, `video-param-${paramType}`);
};
const propTypes = {
  className: PropTypes.string,
  videoParams: PropTypes.object.isRequired,
  onVideoParamChange: PropTypes.func.isRequired
};
function VideoPopoverAdvancedControls(props) {
  const {
    videoParams,
    onVideoParamChange
  } = props;
  const handleVideoParamChange = (paramType, checked) => {
    onVideoParamChange(Object.assign({}, videoParams, {
      [paramType]: checked
    }));
  };
  return /*#__PURE__*/_jsx(Fieldset, {
    paddingInline: "500",
    _size: "small",
    children: /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text('RichTextLib.video.advanced.paramsLabel'),
      tooltip: I18n.text('RichTextLib.video.advanced.paramsHelp'),
      tooltipPlacement: "top right",
      children: /*#__PURE__*/_jsx(ToggleGroup, {
        name: "video-params",
        children: Object.values(VideoParamTypes).map(paramType => renderVideoParamCheckbox(paramType, videoParams[paramType], handleVideoParamChange))
      })
    })
  });
}
VideoPopoverAdvancedControls.propTypes = propTypes;
VideoPopoverAdvancedControls.displayName = 'VideoPopoverAdvancedControls';
export default VideoPopoverAdvancedControls;